<template>
  <g>
    <path
      d="M12 21.0002C14.2091 21.0002 16 19.2093 16 17.0002C16 14.791 14.2091 13.0002 12 13.0002C9.79086 13.0002 8 14.791 8 17.0002C8 19.2093 9.79086 21.0002 12 21.0002Z"
    />
    <path
      d="M12 3.00018C8.49 3.00018 5.28 4.29018 2.8 6.41018C2.36 6.79018 2.32 7.47018 2.74 7.89018L6.34 11.4902C6.7 11.8502 7.26 11.8802 7.66 11.5702C8.86 10.6302 10.37 10.0702 12 10.0702C13.64 10.0702 15.14 10.6302 16.34 11.5602C16.74 11.8702 17.3 11.8402 17.65 11.4802L21.25 7.88018C21.67 7.46018 21.63 6.78018 21.18 6.40018C18.72 4.28018 15.51 3.00018 12 3.00018Z"
    />
  </g>
</template>
